module.exports = __webpack_public_path__ + "static/media/no-questions.986a7f53.svg";